import { z } from 'zod';
import { PRODUCT_SORT } from '../constants.js';
import { paginationQuerySchema } from './common.js';

/** Product listing / filtering (spec section 4: "Product listing functionality"). */
export const productListQuerySchema = paginationQuerySchema.extend({
  category: z.string().optional(),
  collection: z.string().optional(),
  /** one tag, as stored (lower case) */
  tag: z.string().max(60).optional(),
  type: z.string().optional(),
  q: z.string().max(200).optional(),
  minPrice: z.coerce.number().int().min(0).optional(),
  maxPrice: z.coerce.number().int().min(0).optional(),
  inStock: z
    .union([z.literal('true'), z.literal('false'), z.boolean()])
    .transform((v) => v === true || v === 'true')
    .optional(),
  material: z.string().optional(),
  // Comma-separated attribute filters, e.g. color=red,blue
  color: z.string().optional(),
  size: z.string().optional(),
  sort: z
    .enum([
      PRODUCT_SORT.RELEVANCE,
      PRODUCT_SORT.FEATURED,
      PRODUCT_SORT.NEWEST,
      PRODUCT_SORT.PRICE_ASC,
      PRODUCT_SORT.PRICE_DESC,
    ])
    .default(PRODUCT_SORT.RELEVANCE),
});

export const searchQuerySchema = paginationQuerySchema.extend({
  q: z.string().min(1).max(200),
});

export type ProductListQuery = z.infer<typeof productListQuerySchema>;
